import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const packagesAPI = createApi({
    reducerPath: "packagesAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllCombos: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/combo?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["combos"],
        }),
        getSpecificComboDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/combo/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createCombo: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/combo",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["combos"],
        }),
        updateCombo: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/combo`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["combos"],
        }),
        deleteCombo: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/combo/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["combos"],
        }),


        getAllPackages: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/product?page=${page}&limit=${size}&isPackage=true`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["packages"],
        }),
        createPackage: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/product-package",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["packages"],
        }),
        updatePackage: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product-package`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["packages"],
        })
    })
});

export const { 
    useGetAllCombosMutation,
    useGetSpecificComboDetailsMutation,
    useCreateComboMutation,
    useUpdateComboMutation,
    useDeleteComboMutation,

    useGetAllPackagesMutation,
    useCreatePackageMutation,
    useUpdatePackageMutation
} = packagesAPI;

export default packagesAPI;